import React from 'react';
import { motion } from 'framer-motion';

export const BreathingAura = ({ variant = 'calm' }) => {
  const variants = {
    calm: 'bg-primary/20',
    stress: 'bg-destructive/20',
    focus: 'bg-accent/20',
  };

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden">
      <motion.div
        className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full blur-3xl ${variants[variant]}`}
        animate={{
          scale: [1, 1.3, 1],
          opacity: [0.3, 0.6, 0.3],
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />
    </div>
  );
};